<script setup lang="ts">

import { useWelcomeFlowStore } from "../WelcomeFlowStore";

const welcomeFlowStore = useWelcomeFlowStore();

</script>

<template>

    <div class="mx-auto flex flex-col items-center justify-center scale-[80%] lg:scale-100 -mt-2 -mb-4 lg:mt-0 lg:mb-0">
        <div class="bg-amber-500 dark:bg-white border-black border-[5px]
                    text-black inline-block py-0.5 px-5 3xl:py-1 3xl:px-8 tracking-widest rounded-xl uppercase
                    text-center dark:opacity-70"
             :class="{ '!opacity-100': welcomeFlowStore.hasMatch }">

            <div class="flex flex-col justify-center max-w-[70vw] overflow-hidden">
                
                <span class="text-xs"
                      :class="{'opacity-100': welcomeFlowStore.hasMatch}">
                    {{ welcomeFlowStore.vehicle?.regoState ?? 'Australia' }}
                </span>

                <span class="w-full text-4xl uppercase lg:text-4xl font-bold text-black !outline-none text-center">
                    {{ welcomeFlowStore.vehicle?.rego ?? 'Ur Rego' }}
                </span>

                <span class="text-xs"
                      :class="{'opacity-100': welcomeFlowStore.hasMatch}">
                    {{ welcomeFlowStore.vehicle?.app?.name ?? 'your dealership' }}
                </span>
                
            </div>

        </div>        
    </div>

</template>